import React from 'react';
import { motion } from 'framer-motion';

const PlanningEarly = () => {
  const scrollToForm = () => {
    document.getElementById('lead-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 bg-limestone-warm text-mission-green relative overflow-hidden border-y border-olive-sage/10">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <motion.div
           initial={{ opacity: 0, y: 20 }}
           whileInView={{ opacity: 1, y: 0 }}
           viewport={{ once: true }}
        >
          <span className="inline-block px-4 py-1 bg-terracotta text-white text-[10px] font-bold uppercase tracking-[0.2em] rounded-full mb-6">
            Season Highlight
          </span>
          <h2 className="font-serif text-3xl md:text-5xl mb-8">
            December Parties Start in July
          </h2>
          <p className="text-lg md:text-xl font-light text-mission-green/80 mb-12 max-w-2xl mx-auto leading-relaxed">
            The strongest December dates are usually planned before fall. Booking early gives your team better date options, better planning time, and a smoother event experience.
          </p>
          <button 
            onClick={scrollToForm}
            className="px-10 py-4 bg-mission-green text-spanish-ivory font-semibold rounded hover:bg-antique-gold hover:text-mission-dark transition-all duration-300 uppercase tracking-widest text-sm shadow-xl"
          >
            Start Planning Your December Event
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default PlanningEarly;